import { z } from "zod";

export const cardSchema = z.object({
  description: z.string()
    .min(1, "Description is required.")
    .max(100, "Description must be 100 characters or fewer."),
});

export type CardFormData = z.infer<typeof cardSchema>;
